import React, { FC, useState } from 'react';

import {
	BUTTON_TYPES,
	EvButton,
	EvComboboxOption,
	EvIcon,
	EvSelectNew,
	RemoveIcon
} from '@evinced-private/ui-common';

import { IScopeRuleUIFormat } from '../../../../interfaces/ScopeRuleUIFormat';
import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';

const REMOVE_ISSUE_BUTTON_TITLE = 'Remove Issue Type Rule';
const ISSUE_TYPES_ACTIONS: EvComboboxOption[] = [
	{ label: 'Include Issue Types', value: SCOPE_ACTIONS.INCLUDE },
	{ label: 'Exclude Issue Types', value: SCOPE_ACTIONS.EXCLUDE }
];

interface IIssueTypesRuleRowProps {
	rule: IScopeRuleUIFormat;
	issueTypesList: EvComboboxOption[];
	onRemove: () => void;
	onRuleChange: (rule: IScopeRuleUIFormat) => void;
}

export const IssueTypesRuleRow: FC<IIssueTypesRuleRowProps> = ({
	rule,
	issueTypesList,
	onRemove,
	onRuleChange
}) => {
	const [selectedAction, setSelectedAction] = useState<EvComboboxOption>(
		ISSUE_TYPES_ACTIONS.find((action) => action.value === rule.scopeAction)
	);

	const [selectedIssueTypes, setSelectedIssueTypes] = useState<EvComboboxOption[]>(() => {
		if (rule.issueTypes?.length) {
			return rule.issueTypes.map((issueType: string) => {
				return { label: issueType, value: issueType };
			});
		}
		return [];
	});

	return (
		<div className="rule-row">
			<EvSelectNew
				id="issue-type-rule-select"
				options={ISSUE_TYPES_ACTIONS}
				selectedValue={[selectedAction]}
				onSelectChange={(selected) => {
					setSelectedAction(selected[0]);
					onRuleChange({ ...rule, scopeAction: selected[0].value as SCOPE_ACTIONS });
				}}
				placeholder="Select Action"
				label="Action"
				className="rule-action-control"
			/>
			<EvSelectNew
				id="issue-types-select-list"
				options={issueTypesList}
				selectedValue={selectedIssueTypes}
				onSelectChange={(selected) => {
					setSelectedIssueTypes(selected);
					onRuleChange({ ...rule, issueTypes: selected.map((issue) => issue.label) });
				}}
				placeholder="Select Issue Type"
				label="Issue Type"
				isMultiple
				className="rule-value-control"
				maxDisplayedItems={200}
			/>
			<EvButton
				className="delete-rule-btn"
				key="Remove"
				title={REMOVE_ISSUE_BUTTON_TITLE}
				type={BUTTON_TYPES.ICON}
				onClick={onRemove}
			>
				<EvIcon icon={RemoveIcon} />
			</EvButton>
		</div>
	);
};
